import React from 'react';
import { Layout } from '../../components/common';
import Header from '../../components/theme/Header';
import Footer from '../../components/theme/Footer';
import { FormattedMessage } from 'react-intl';
import SEO from '../../components/common/SEO';
import CarouselCustom from '../../components/common/IndexPage/carousel';
import TitleSection from '../../components/common/TitleSection';
import MainContentHolder from './styles';
import PricesMarina from '../../components/common/Prices/pricesMarina';

function importAll(r) {
  return r.keys().map(r);
}

// const imgArray = importAll(require.context('../../../static/Marina', false, /\.(png|jpe?g|svg)$/));

import img1 from '../../../static/Marina/01.jpg';
import img2 from '../../../static/Marina/02.jpg';
import img3 from '../../../static/Marina/03.jpg';
import img4 from '../../../static/Marina/04.jpg';
import img5 from '../../../static/Marina/05.jpg';
import img6 from '../../../static/Marina/06.jpg';
import img7 from '../../../static/Marina/07.jpg';
import img8 from '../../../static/Marina/08.jpg';
import img9 from '../../../static/Marina/09.jpg';
import img10 from '../../../static/Marina/10.jpg';
import img11 from '../../../static/Marina/11.jpg';
import img12 from '../../../static/Marina/12.jpg';
import img13 from '../../../static/Marina/13.jpg';
import img14 from '../../../static/Marina/14.jpg';
import img15 from '../../../static/Marina/15.jpg';
import img16 from '../../../static/Marina/16.jpg';
import img17 from '../../../static/Marina/17.jpg';
import img18 from '../../../static/Marina/18.jpg';
import img19 from '../../../static/Marina/19.jpg';
import img20 from '../../../static/Marina/20.jpg';
import img21 from '../../../static/Marina/21.jpg';
import img22 from '../../../static/Marina/22.jpg';
import img23 from '../../../static/Marina/23.jpg';
import img24 from '../../../static/Marina/24.jpg';
import img25 from '../../../static/Marina/25.jpg';

let imgArray = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25
];

const apartmentMarina = () => (
  <Layout>
    <React.Fragment>
      <Header />
      <SEO title="ApartmentMarina" />
      <MainContentHolder className="main-content-holder">
        <TitleSection section="marinaHeader" />
        <div className="main-content-holder">
          <CarouselCustom imgArray={imgArray} />
        </div>
        <p className="apartment-description">
          <FormattedMessage id="marinaDescription" />
        </p>
        <ul className="apartmentItemList">
          <li>
            <FormattedMessage id="airConditionerDining" />
          </li>
          <li>
            <FormattedMessage id="washingMachine" />
          </li>
          <li>
            <FormattedMessage id="microwave" />
          </li>
          <li>
            <FormattedMessage id="fridge" />
          </li>
          <li>
            <FormattedMessage id="oven" />
          </li>
          <li>
            <FormattedMessage id="kettle" />
          </li>
          <li>
            <FormattedMessage id="coffemachine" />
          </li>
          <li>
            <FormattedMessage id="hairdryer" />
          </li>
          <li>
            <FormattedMessage id="iron" />
          </li>
          <li>
            <FormattedMessage id="tv" />
          </li>
          <li>
            <FormattedMessage id="wifi" />
          </li>
        </ul>

        <br />
        <div>
          <FormattedMessage id="condition13_1" />
          <FormattedMessage tagName="sup" id="condition13_2" />
          <FormattedMessage id="condition13_3" />
        </div>

        <h3>
          <FormattedMessage id="pricesMarinaText" />
        </h3>
        <p>
          <FormattedMessage id="pricesInformation" />
        </p>
        <div className="table-price-holder">
          <PricesMarina />
        </div>
      </MainContentHolder>
      <Footer />
    </React.Fragment>
  </Layout>
);

export default apartmentMarina;
